






import { Component, Mixins } from "vue-property-decorator";

@Component
export default class NavigationPane extends Mixins() {
}
